// @ngInject
function CurrenciesApiService($q, $rootScope, DS, DSHttpAdapter) {

    return {
        getAll: getAll,
        getCurrency: getCurrency,
        save: save,
        deleteCurrency: deleteCurrency
    };

    function getAll(filter) {
        var deferred = $q.defer();

        var params = {};
        if (!_.isEmpty(filter)) {
            params.filter = filter;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + 'currencies', { params: params }).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function getCurrency(id) {
        var deferred = $q.defer();
        DSHttpAdapter.GET(DS.defaults.basePath + 'currencies/' + id)
            .then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    function save(currency) {
        var deferred = $q.defer();
        DSHttpAdapter.POST(DS.defaults.basePath + 'currencies/saveCurrency/', currency).then(function (response) {
            deferred.resolve(response);
            $rootScope.$emit('Currency.Updated', response.data);
            $rootScope.$emit('Currency.Changed', response.data);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function deleteCurrency(id) {
        var deferred = $q.defer();
        DSHttpAdapter.GET(DS.defaults.basePath + 'currencies/deleteCurrency/' + id).then(function (response) {
            deferred.resolve(response);
            $rootScope.$emit('Currency.Deleted', response.data);
            $rootScope.$emit('Currency.Changed', response.data);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }
}


angular.module('currencies.api', [])
  .factory('CurrenciesApiService', CurrenciesApiService);
